import { Box, Button, Typography } from '@mui/joy';
import { Divider } from './Divider';
import openSecrets from '../../assets/os-logo-color.png';
import { useYear } from '../../providers/YearProvider';

// THIS VERSION WAS USED PRIOR TO THE ANALYSIS PAGE EXISTING. WE CAN USE IT AGAIN IF THERE IS 2026 VERSION.
export const LandingPageHeading = () => {
	const { year } = useYear();
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				flexGrow: 1,
				width: { xs: '280px', md: '320px' }
			}}
		>
			<Typography level='h1' sx={{ fontWeight: 600 }}>Women,</Typography>
			<Typography level='h1' sx={{ fontWeight: 600 }}>Money,</Typography>
			<Typography level='h1' sx={{ textWrap: 'nowrap', fontWeight: 600 }}>
				& Politics
			</Typography>
			<Typography level='h1' sx={{ marginBottom: '14px', fontWeight: 600 }}>
				Watch
			</Typography>
			<Divider sx={{ width: '100%', maxWidth: '275px' }} />
			<Typography level='h1' sx={{ fontWeight: 300, marginY: '14px' }}>
				{year}
			</Typography>
			{year === 2024 ? (
				<>
					<Typography level='body2' sx={{ marginTop: '42px' }}>
						Data fueled in part by:
					</Typography>
					<a href='https://www.opensecrets.org/' target='__blank'>
						<img src={openSecrets} width={194} alt='Open Secrets logo' />
					</a>
				</>
			) : (
				<>
					<a href='/research/cawp-women-money-and-politics-series/money-watch-2024' target='__blank'>
						<Button
							variant='outlined'
							color='neutral'
							sx={{
								fontSize: '1.125rem',
								paddingY: '14px',
								paddingX: '19px',
								color: '#000000DE',
								border: '1px solid #374151',
								backgroundColor: '#FFFFFF'
						}}
						>
							Explore the 2024 Watch
						</Button>
					</a>
				</>
			)}
		</Box>
	);
};
